import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-125e999e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "self-recycling-page" }
const _hoisted_2 = { class: "box-title" }
const _hoisted_3 = {
  key: 0,
  class: "primary"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = { class: "box-items" }
const _hoisted_6 = { class: "index" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  t: "1660880108979",
  class: "icon icon-scan",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "4698",
  width: "200",
  height: "200"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M725.333333 128h149.184C886.421333 128 896 137.578667 896 149.482667V298.666667a42.666667 42.666667 0 1 0 85.333333 0V149.482667A106.752 106.752 0 0 0 874.517333 42.666667H725.333333a42.666667 42.666667 0 1 0 0 85.333333z m170.666667 597.333333v149.184c0 11.904-9.578667 21.482667-21.482667 21.482667H725.333333a42.666667 42.666667 0 1 0 0 85.333333h149.184A106.752 106.752 0 0 0 981.333333 874.517333V725.333333a42.666667 42.666667 0 1 0-85.333333 0z m-597.333333 170.666667H149.482667A21.418667 21.418667 0 0 1 128 874.517333V725.333333a42.666667 42.666667 0 1 0-85.333333 0v149.184A106.752 106.752 0 0 0 149.482667 981.333333H298.666667a42.666667 42.666667 0 1 0 0-85.333333zM128 298.666667a42.666667 42.666667 0 1 1-85.333333 0V149.482667A106.752 106.752 0 0 1 149.482667 42.666667H298.666667a42.666667 42.666667 0 1 1 0 85.333333H149.482667C137.578667 128 128 137.578667 128 149.482667V298.666667zM85.333333 554.666667a42.666667 42.666667 0 1 1 0-85.333334h853.333334a42.666667 42.666667 0 1 1 0 85.333334H85.333333z",
    fill: "#ffffff",
    "p-id": "4699"
  })
], -1))
const _hoisted_8 = { class: "box-item flex-start" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "index" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    t: "1660880108979",
    class: "icon icon-scan icon-tips",
    viewBox: "0 0 1024 1024",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": "4698",
    width: "200",
    height: "200"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M725.333333 128h149.184C886.421333 128 896 137.578667 896 149.482667V298.666667a42.666667 42.666667 0 1 0 85.333333 0V149.482667A106.752 106.752 0 0 0 874.517333 42.666667H725.333333a42.666667 42.666667 0 1 0 0 85.333333z m170.666667 597.333333v149.184c0 11.904-9.578667 21.482667-21.482667 21.482667H725.333333a42.666667 42.666667 0 1 0 0 85.333333h149.184A106.752 106.752 0 0 0 981.333333 874.517333V725.333333a42.666667 42.666667 0 1 0-85.333333 0z m-597.333333 170.666667H149.482667A21.418667 21.418667 0 0 1 128 874.517333V725.333333a42.666667 42.666667 0 1 0-85.333333 0v149.184A106.752 106.752 0 0 0 149.482667 981.333333H298.666667a42.666667 42.666667 0 1 0 0-85.333333zM128 298.666667a42.666667 42.666667 0 1 1-85.333333 0V149.482667A106.752 106.752 0 0 1 149.482667 42.666667H298.666667a42.666667 42.666667 0 1 1 0 85.333333H149.482667C137.578667 128 128 137.578667 128 149.482667V298.666667zM85.333333 554.666667a42.666667 42.666667 0 1 1 0-85.333334h853.333334a42.666667 42.666667 0 1 1 0 85.333334H85.333333z",
      fill: "#ffffff",
      "p-id": "4699"
    })
  ])
], -1))
const _hoisted_10 = { class: "scan-tips" }
const _hoisted_11 = { class: "box-item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "index" }, null, -1))
const _hoisted_13 = { class: "box-title" }

import { ref, computed } from 'vue';
  import { ColorVariants } from '@/constants';
  import { useI18n } from 'vue-i18n';
  import { ColletionBinStore } from '@/stores';
  import { IUserRequest } from '@/types/user-request';
  import { useToast } from 'bootstrap-vue-3';

  interface IProps {
    collectionBinStore: ColletionBinStore;
  }

  interface IEmits {
    (event: 'submited', data: IUserRequest): void;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    collectionBinStore: null
  },
  emits: ["submited"],
  setup(__props: any, { emit: emits }: { emit: ({
    (event: 'submited', data: IUserRequest): void;
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    collectionBinStore: ColletionBinStore;
  }

  
  
  const toast = useToast();

  const { t } = useI18n();
  const barcodes = ref<string[]>(['']);

  const addItem = () => {
    const num = barcodes.value.filter(v => v.trim()).length;
    if (remainingNumber.value !== null && Number(remainingNumber.value) <= num) {
      toast.show({ title: t('Tips'), body: remainingNumberTips }, { variant: 'warning' });
      return;
    }
    barcodes.value.push('');
  };

  const submitButtonDisabled = computed(() => {
    return barcodes.value.filter(Boolean).length === 0;
  });

  const remainingNumber = computed(() => {
    return props.collectionBinStore.userInfo.remaining_number_of_barcodes;
  });
  const remainingNumberTips = computed(() => {
    if (remainingNumber.value === null || !props.collectionBinStore.userInfo.id) {
      return '';
    }
    return t('remaining_number_tips', { num: remainingNumber.value });
  });

  function handleGetCode(index: number, code: string) {
    barcodes.value[index] = code;
  }

  async function handleSubmit() {
    const data = await props.collectionBinStore.request(barcodes.value);
    // 提交完刷新store数据
    await props.collectionBinStore.fetchData();
    emits('submited', data);
  }

return (_ctx: any,_cache: any) => {
  const _component_b_form_input = _resolveComponent("b-form-input")!
  const _component_AppScanner = _resolveComponent("AppScanner")!
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", null, _toDisplayString(_unref(t)('step', { index: 1 })), 1),
      _createElementVNode("p", null, [
        _createTextVNode(_toDisplayString(_unref(t)('step1')), 1),
        (_unref(remainingNumberTips))
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
              _hoisted_4,
              _createTextVNode(" " + _toDisplayString(_unref(remainingNumberTips)), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(barcodes.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "box-item"
        }, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(index + 1) + ".", 1),
          _createVNode(_component_b_form_input, {
            modelValue: barcodes.value[index],
            "onUpdate:modelValue": ($event: any) => ((barcodes.value[index]) = $event),
            modelModifiers: { trim: true }
          }, null, 8, ["modelValue", "onUpdate:modelValue"]),
          _createVNode(_component_AppScanner, {
            onChange: ($event: any) => (handleGetCode(index, $event as any))
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 2
          }, 1032, ["onChange"])
        ]))
      }), 128)),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(t)('scan_tips')), 1)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createVNode(_component_b_button, {
          variant: _unref(ColorVariants).outlinePrimary,
          onClick: addItem
        }, {
          default: _withCtx(() => [
            _createTextVNode(" + " + _toDisplayString(_unref(t)('add_more_item')), 1)
          ]),
          _: 1
        }, 8, ["variant"])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("h2", null, _toDisplayString(_unref(t)('step', { index: 2 })), 1),
      _createElementVNode("p", null, _toDisplayString(_unref(t)('step2')), 1)
    ]),
    _createVNode(_component_b_button, {
      disabled: _unref(submitButtonDisabled),
      class: "btn-block",
      pill: "",
      variant: _unref(ColorVariants).primary,
      onClick: handleSubmit
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('done')), 1)
      ]),
      _: 1
    }, 8, ["disabled", "variant"])
  ]))
}
}

})